import type { ThunkReturnType } from "types";
import { createAsyncThunk } from "infrastructure/store/lib";
import type { AsyncThunk, RootState } from "infrastructure/store";
import { ApiState } from "infrastructure/api";
import { ApiRouteTypes } from "consts/enpoints/api";
import { payloadCreator } from "util/api";
import { concat } from "util/support";
import { selectIsNotMor } from "features/auth/selectors";
import { sliceToken } from "./state";
import type { PaymentMethod, PaymentMethodResponse, PaymentMethodsResponse } from "./types";
import { updateOrCreatePaymentMethod, getPaymentMethods } from "./api";

export const getPaymentMethodsThunk: AsyncThunk<
    ThunkReturnType<PaymentMethodsResponse>,
    string | undefined,
    {}
> = createAsyncThunk(
    concat([sliceToken, ApiRouteTypes.GetPaymentMethods]),
    payloadCreator(getPaymentMethods),
    {
        condition: (_, { getState }) => {
            const { paymentMethods } = getState() as RootState;

            return (
                selectIsNotMor(getState()) &&
                !paymentMethods.paymentMethodsSlice &&
                ![ApiState.Pending].includes(paymentMethods.paymentMethodsLoadingState)
            );
        }
    }
);

export const updateOrCreatePaymentMethodThunk: AsyncThunk<
    ThunkReturnType<PaymentMethodResponse>,
    Partial<PaymentMethod>,
    {}
> = createAsyncThunk(
    concat([sliceToken, ApiRouteTypes.PostPaymentMethods]),
    payloadCreator(updateOrCreatePaymentMethod),
    {
        condition: (_, { getState }) => {
            const { paymentMethods } = getState() as RootState;

            return (
                ![ApiState.Pending].includes(paymentMethods.paymentMethodsLoadingState)
            );
        }
    }
);
